module.exports = __webpack_public_path__ + "static/media/michael@3x.5d8671fa.png";